import $ from 'jquery';
import { OnlineMoveInApi } from '../api/apicollection';

export default function RentalOrderViewModel() {

    let rentableInventoryId = $('#RentableInventoryId').val();
    let locationTimeZone = $('#LocationTimeZone').val();
    let addOnId = $('#RentableInventoryAddOnId').val();
    let roomRate = parseFloat($('#RoomRate').val());
    let insuranceRate = parseFloat($('#InsuranceAmount').val());

    this.isExempt = ko.observable(false);
    this.isReservation = ko.observable($('#IsReservation').val() === 'True');
    this.monthlyRate = ko.observable(roomRate + insuranceRate);

    this.costs = this.isReservation() ?
        {
            totalMoveInCost : 0.00,
            individualCharges: []
        }
        : ko.observable();

    this.toggleExempt = () => {
        if (!this.isReservation()) {
            $('#checkoutButton').prop('disabled', true);
            $('#loadingSpinner').show();
            this.getCosts();
        }

        return true;
    };

    this.getCosts = () => {
      let request = {
        rentableInventoryId: rentableInventoryId,
        addOnId: addOnId,
        locationTimeZone: locationTimeZone,
        isTaxExempt: this.isExempt()
      }
        OnlineMoveInApi.getMoveInCost(request).then(data => {
            this.costs(data.data);
            let rent = 0.00;
            data.data.individualCharges.forEach(charge =>{
              if (charge.quantity === 1){
                rent += (charge.amount + charge.taxAmount);
              }
            });
            this.monthlyRate(rent);

            $('#loadingSpinner').hide();
            $('#checkoutButton').prop('disabled', false);
        });
    };

    this.formatDollarAmount = amount => {
        return `$${amount.toFixed(2)}`;
    };

    if (this.isReservation()) {
        $('#loadingSpinner').hide();
    } else {
        this.getCosts();
    }


    return this;
}